module.exports = __webpack_public_path__ + "img/Icon_Gift_blue.41807637.svg";